import {
  HandsSection,
  ImageCircle,
  SectionCircle,
  BlackDot,
  DescriptionEthic,
  ListItemOther,
  ListItemHonesty,
  ContainerList,
  SectionValues,
  Container,
  Section,
  TextBlock,
  Title,
  LogoImage,
  Doctor,
  Ampoules,
  Hands,
  Subtitle,
  List,
  ListItem,
  RedDot,
  Description,
  Commitment,
  ContainerAbout,
  CircleAnimation,
  SquareImage
} from "./About.style";
import DoctorImage from "../../assets/AboutContainer/doctor.png";
import Logo from "../../assets/AboutContainer/logo.png";
import AmpoulesImage from "../../assets/AboutContainer/ampoules.png";
import HandsImageRight from "../../assets/AboutContainer/1.png";
import HandsImageLeft from "../../assets/AboutContainer/2.png";
import CircleImage from "../../assets/AboutContainer/circlepng.png";
import Square from "../../assets/AboutContainer/square.png";

const AboutContainer = () => {
  return (
    <ContainerAbout>
      <Container>
        {/* Header Section */}
        <Section>
          <Doctor src={DoctorImage} alt="Doctor" />
          <TextBlock>
            <Title>
              Calidad y experiencia <br />
              al servicio de la <br />
              medicina integrativa
            </Title>
            <LogoImage src={Logo} alt="Dr. Reckeweg Logo" />
            <CircleAnimation>
              <img src={CircleImage} alt="Circle" />
            </CircleAnimation>
          </TextBlock>
        </Section>

        {/* Values Section */}
        <SectionValues>
          <Subtitle>¿Qué nos mueve?</Subtitle>
          <ContainerList>
            <List>
              <ListItem>
                <RedDot /> Innovación
              </ListItem>
              <Description>
                <BlackDot /> Somos capaces de hacer nuevas y mejores cosas cada
                día, buscando satisfacer las necesidades de los demás y marcando
                un liderazgo en nuestro entorno.
              </Description>
              <ListItemHonesty>
                <RedDot /> Honestidad
              </ListItemHonesty>
              <ListItemOther>
                <RedDot /> Transparencia
              </ListItemOther>
              <ListItemOther>
                <RedDot /> Ética
              </ListItemOther>
              <DescriptionEthic>
                <BlackDot /> Compartimos principios firmes que rigen nuestro
                diario a vivir.
              </DescriptionEthic>
              <DescriptionEthic>
                <BlackDot /> Comprometidos con la verdad y la justicia.
              </DescriptionEthic>
            </List>
            <Ampoules src={AmpoulesImage} alt="Ampoules" />
          </ContainerList>
        </SectionValues>

        {/* Commitment Section */}
        <Commitment>
          <p>
            Cultivamos vínculos duraderos con nuestros clientes, inspirados en
            la confianza, el respeto y un compromiso genuino con la integridad.
          </p>
        </Commitment>

        <HandsSection>
          <Hands src={HandsImageRight} alt="Hands" />
          <Hands src={HandsImageLeft} alt="Hands" />
        </HandsSection>

        <SquareImage>
          <img src={Square} alt="Background" />
        </SquareImage>

        {/* Service Section */}
        <SectionCircle>
          <ImageCircle>
            <img src={CircleImage} alt="Circle" />
          </ImageCircle>
          <List>
            <ListItem>
              <RedDot /> Servicio al cliente
            </ListItem>
            <ListItem>
              <RedDot /> Eficacia
            </ListItem>
            <ListItem>
              <RedDot /> Excelencia
            </ListItem>
            <Description>
              <BlackDot />
              Estamos comprometidos a efectuar nuestros labores en el menor
              tiempo posible sin que eso signifique dejar de hacerlas con
              excelencia y nos sentimos recompensados si nuestro mejor esfuerzo
              satisface a los demás.
            </Description>
          </List>
        </SectionCircle>
      </Container>
    </ContainerAbout>
  );
};

export default AboutContainer;
